import React, { useState } from 'react';
import { Table } from 'antd';
import { useT } from 'hooks/Locale/useT';
import CommentModal from '../Modals/CommentModal';
import { LocaleText, Tag } from 'ui';
import { TagStatus } from 'ui/Tag/types';
import GradingModel from 'components/Grading/GradingModal';
import RegenerateTaskButton from 'components/Grading/RegenerateTaskButton';
import { config } from 'config/config';
import moment from 'moment';

interface AssessmentTableInterface {
    data: any[];
    onReload?: Function;
}

const AssessmentTable: React.FC<AssessmentTableInterface> = ({ data, onReload }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);
    const [selectedAttemptData, setSelectedAttemptData] = useState<any>(null);

    const columns = [
        {
            title: t('general.title'),
            dataIndex: 'title',
            render: (_text: string, record: any) => <LocaleText text={record.title} />,
        },
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.result_comment'),

            render: (_text: string, record: any) => (
                <div
                    className={record.comment ? 'pointer' : 'disabled'}
                    onClick={() => (record?.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i className="fa-sharp fa-regular fa-comment-check"></i>
                </div>
            ),
        },
        {
            title: t('program.attempt_end'),
            dataIndex: 'attemptEnd',
            render: (date: string | null) => (date ? moment(date).format(config.defaultFullDateFormat) : '-'),
            
        },
        {
            title: t('program.assessment_view'),
            render: (_text: string, record: any) => {
                // 24.3.8: a deleted grading task can be regenerated by PowerAdmin
                if (record.gradingTaskDeleted) {
                    return (
                        <RegenerateTaskButton
                            attemptId={record.attemptId}
                            onDone={() => onReload?.()}
                        />
                    );
                }

                return (
                    <div
                        className="pointer"
                        onClick={() => {
                            setSelectedAttemptData({
                                attemptId: record.attemptId,
                                type: 'ASSESSMENT',
                                submissionId: record.submissionId,
                            });
                        }}
                    >
                        <i className="fa-sharp fa-light fa-diagram-subtask"></i>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={'id'}
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
            <GradingModel
                onCancel={() => {
                    setSelectedAttemptData(null);
                }}
                attemptData={selectedAttemptData}
                onGraded={() => {}}
            />
        </>
    );
};

export default AssessmentTable;
